import EmergencyCategoryForm from "./admissionDocs/EmergencyCategoryForm";
import PatientConsentForm from "./admissionDocs/PatientConsentForm";
import NomncForm from "./admissionDocs/NomncForm";
import PhysicianOrderForm from "./physicianOrders/PhysicianOrderForm";
import NoaOrderForm from "./physicianOrders/NoaOrderForm";
import SpoOrderForm from "./physicianOrders/SpoOrderForm";
import FaceToFaceEncounterForm from "./physicianOrders/FaceToFaceEncounterForm";
import RnEvalNoteForm from "./nurseNotes/RnEvalNoteForm";
import RnVisitNoteForm from "./nurseNotes/RnVisitNoteForm";
import RnDischargeNoteForm from "./nurseNotes/RnDischargeNoteForm";
import RnMissedVisitForm from "./nurseNotes/RnMissedVisitForm";
import RnSupVisitForm from "./nurseNotes/RnSupVisitForm";
import RnReevalNoteForm from "./nurseNotes/RnReevalNoteForm";
import RnDischargeNonVisitForm from "./nurseNotes/RnDischargeNonVisitForm";
import PtEvalNoteForm from "./ptNotes/PtEvalNoteForm";
import PtVisitNoteForm from "./ptNotes/PtVisitNoteForm";
import PtDischargeNoteForm from "./ptNotes/PtDischargeNoteForm";
import PtMissedVisitForm from "./ptNotes/PtMissedVisitForm";
import PtSupVisitForm from "./ptNotes/PtSupVisitForm";
import PtReevalNoteForm from "./ptNotes/PtReevalNoteForm";
import PtDischargeNonVisitForm from "./ptNotes/PtDischargeNonVisitForm";
import MswEvalNoteForm from "./mswNotes/MswEvalNoteForm";
import MswVisitNoteForm from "./mswNotes/MswVisitNoteForm";
import MswMissedVisitForm from "./mswNotes/MswMissedVisitForm";
import ChhaVisitNoteForm from "./chhaNotes/ChhaVisitNoteForm";
import ChhaMissedVisitForm from "./chhaNotes/ChhaMissedVisitForm";
import OtEvalNoteForm from "./otNotes/OtEvalNoteForm";
import OtVisitNoteForm from "./otNotes/OtVisitNoteForm";
import OtSupVisitForm from "./otNotes/OtSupVisitForm";
import OtReevalNoteForm from "./otNotes/OtReevalNoteForm";
import OtMissedVisitForm from "./otNotes/OtMissedVisitForm";
import OtDischargeNoteForm from "./otNotes/OtDischargeNoteForm";
import OtDischargeNonVisitForm from "./otNotes/OtDischargeNonVisitForm";
import StEvalNoteForm from "./stNotes/StEvalNoteForm";
import StReevalNoteForm from "./stNotes/StReevalNoteForm";
import StSupVisitForm from "./stNotes/StSupVisitForm";
import StVisitNoteForm from "./stNotes/StVisitNoteForm";
import StMissedVisitForm from "./stNotes/StMissedVisitForm";
import StDischargeNoteForm from "./stNotes/StDischargeNoteForm";
import StDischargeNonVisitForm from "./stNotes/StDischargeNonVisitForm";

import DailyLogForm from "./dailyLogs/DailyLogForm";

/**
 * Form types that render their own purpose-built layout instead of the generic
 * field grid. Both the on-screen page and the print page read this map, so a
 * new form only has to be registered once to gain both.
 *
 * Every component here takes `{ patient, clinicalForm, onBack, printMode }`
 * and must render read-only, without page chrome or action buttons, when
 * `printMode` is true.
 */
export const DEDICATED_FORM_PAGES = {
  emergency_category: EmergencyCategoryForm,
  consent_form: PatientConsentForm,
  non_coverage_medicare: NomncForm,
  noa_order: NoaOrderForm,
  physician_order: PhysicianOrderForm,
  supplemental_physician_order: SpoOrderForm,
  face_to_face_encounter: FaceToFaceEncounterForm,
  rn_eval_note: RnEvalNoteForm,
  rn_visit_note: RnVisitNoteForm,
  rn_discharge_note: RnDischargeNoteForm,
  rn_missed_visit: RnMissedVisitForm,
  rn_sup_visit: RnSupVisitForm,
  rn_reeval_note: RnReevalNoteForm,
  rn_discharge_non_visit: RnDischargeNonVisitForm,
  pt_eval_note: PtEvalNoteForm,
  pt_visit_note: PtVisitNoteForm,
  pt_discharge_note: PtDischargeNoteForm,
  pt_missed_visit: PtMissedVisitForm,
  pt_sup_visit: PtSupVisitForm,
  pt_reeval_note: PtReevalNoteForm,
  pt_discharge_non_visit: PtDischargeNonVisitForm,
  msw_eval_note: MswEvalNoteForm,
  msw_visit_note: MswVisitNoteForm,
  msw_missed_visit: MswMissedVisitForm,
  chha_visit_note: ChhaVisitNoteForm,
  chha_missed_visit: ChhaMissedVisitForm,
  ot_eval_note: OtEvalNoteForm,
  ot_visit_note: OtVisitNoteForm,
  ot_sup_visit: OtSupVisitForm,
  ot_reeval_note: OtReevalNoteForm,
  ot_missed_visit: OtMissedVisitForm,
  ot_discharge_note: OtDischargeNoteForm,
  ot_discharge_non_visit: OtDischargeNonVisitForm,
  st_eval_note: StEvalNoteForm,
  st_reeval_note: StReevalNoteForm,
  st_sup_visit: StSupVisitForm,
  st_visit_note: StVisitNoteForm,
  st_missed_visit: StMissedVisitForm,
  st_discharge_note: StDischargeNoteForm,
  st_discharge_non_visit: StDischargeNonVisitForm,
  daily_log_form: DailyLogForm,
};

export const getDedicatedFormPage = (formType) =>
  DEDICATED_FORM_PAGES[formType] || null;

/**
 * Dedicated forms keep their answers in their own table, so the generic
 * `formData` blob stays empty for them.
 */
export const hasDedicatedFormPage = (formType) =>
  Boolean(DEDICATED_FORM_PAGES[formType]);
